import React, { useEffect, useState } from 'react';
import api, { clientiApi, ficApi } from '../services/api';

export default function CollegaClientiFic() {
  const [clientiDb,  setClientiDb]  = useState([]);
  const [clientiFic, setClientiFic] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [q,          setQ]          = useState('');
  const [ficQ,       setFicQ]       = useState('');
  const [selDb,      setSelDb]      = useState(null);
  const [selFic,     setSelFic]     = useState(null);
  const [saving,     setSaving]     = useState(false);
  const [msg,        setMsg]        = useState('');
  const [filtroStato,setFiltro]     = useState('tutti'); // tutti | collegati | non_collegati

  useEffect(() => {
    Promise.all([
      clientiApi.getAll(),
      ficApi.clienti(),
    ]).then(([db, fic]) => {
      setClientiDb(db.data?.data || []);
      setClientiFic(fic.data?.data || []);
    }).catch(console.error)
    .finally(() => setLoading(false));
  }, []);

  const dbFiltrati = clientiDb.filter(c => {
    const matchQ = !q || [c.nome,c.indirizzo,c.citta].filter(Boolean).join(' ').toLowerCase().includes(q.toLowerCase());
    const matchS = filtroStato === 'tutti' ? true
                 : filtroStato === 'collegati' ? !!c.fic_cliente_id
                 : !c.fic_cliente_id;
    return matchQ && matchS;
  });

  const ficFiltrati = clientiFic.filter(c =>
    !ficQ || c.name?.toLowerCase().includes(ficQ.toLowerCase()) ||
             (c.vat_number||'').includes(ficQ)
  );

  const collega = async () => {
    if (!selDb || !selFic) return;
    setSaving(true); setMsg('');
    try {
      await api.put(`/clienti/${selDb.id}`, {
        fic_cliente_id: selFic.id,
        fic_nome:       selFic.name,
      });
      // Aggiorna lista locale
      setClientiDb(list => list.map(c => c.id === selDb.id
        ? { ...c, fic_cliente_id: selFic.id, fic_nome: selFic.name }
        : c
      ));
      setMsg(`✅ "${selDb.nome}" collegato a "${selFic.name}"`);
      setSelDb(null);
      setSelFic(null);
    } catch(e) { setMsg('Errore: ' + (e.response?.data?.error||e.message)); }
    finally { setSaving(false); }
  };

  const scollega = async (cliente) => {
    if (!window.confirm(`Scollegare "${cliente.nome}" da FIC?`)) return;
    try {
      await api.put(`/clienti/${cliente.id}`, { fic_cliente_id: 0, fic_nome: '' });
      setClientiDb(list => list.map(c => c.id === cliente.id
        ? { ...c, fic_cliente_id: null, fic_nome: null }
        : c
      ));
      setMsg(`✅ "${cliente.nome}" scollegato da FIC`);
    } catch(e) { setMsg('Errore: ' + e.message); }
  };

  const nCollegati    = clientiDb.filter(c => c.fic_cliente_id).length;
  const nNonCollegati = clientiDb.filter(c => !c.fic_cliente_id).length;

  if (loading) return <div className="loading"><div className="spinner"></div></div>;

  return (
    <div className="page-content">
      <h2 style={{marginBottom:8}}>🔗 Collegamento Clienti DB ↔ FIC</h2>
      <p style={{color:'#6b7280',fontSize:13,marginBottom:16}}>
        Seleziona un cliente dal DB locale (sinistra) e il corrispondente su FIC (destra) poi clicca Collega.
      </p>

      {/* STATS */}
      <div style={{display:'flex',gap:12,marginBottom:16,flexWrap:'wrap'}}>
        <div className="stat-card green" style={{padding:'10px 16px',cursor:'pointer',minWidth:120}}
          onClick={()=>setFiltro('collegati')}>
          <div style={{fontSize:22,fontWeight:700}}>{nCollegati}</div>
          <div style={{fontSize:11,color:'#6b7280'}}>✅ Collegati</div>
        </div>
        <div className="stat-card red" style={{padding:'10px 16px',cursor:'pointer',minWidth:120}}
          onClick={()=>setFiltro('non_collegati')}>
          <div style={{fontSize:22,fontWeight:700}}>{nNonCollegati}</div>
          <div style={{fontSize:11,color:'#6b7280'}}>❌ Non collegati</div>
        </div>
        <div className="stat-card blue" style={{padding:'10px 16px',cursor:'pointer',minWidth:120}}
          onClick={()=>setFiltro('tutti')}>
          <div style={{fontSize:22,fontWeight:700}}>{clientiDb.length}</div>
          <div style={{fontSize:11,color:'#6b7280'}}>👥 Totale</div>
        </div>
      </div>

      {msg && (
        <div style={{
          padding:'10px 16px', borderRadius:8, marginBottom:16, fontSize:13,
          background: msg.includes('✅') ? '#f0fdf4' : '#fff5f5',
          border: `1px solid ${msg.includes('✅') ? '#bbf7d0' : '#fca5a5'}`,
          color:  msg.includes('✅') ? '#16a34a' : '#dc2626',
        }}>
          {msg}
        </div>
      )}

      {/* PANNELLO COLLEGAMENTO */}
      {(selDb || selFic) && (
        <div className="card" style={{marginBottom:16,background:'#fff7ed',border:'2px solid #b30000'}}>
          <div style={{display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
            <div style={{flex:1,minWidth:200}}>
              <div style={{fontSize:11,color:'#9ca3af',marginBottom:4}}>DB LOCALE</div>
              {selDb
                ? <div style={{fontWeight:600}}>{selDb.nome} <span style={{fontSize:11,color:'#9ca3af'}}>{selDb.citta||''}</span></div>
                : <div style={{color:'#9ca3af',fontStyle:'italic',fontSize:13}}>Seleziona cliente DB →</div>
              }
            </div>
            <div style={{fontSize:24}}>🔗</div>
            <div style={{flex:1,minWidth:200}}>
              <div style={{fontSize:11,color:'#9ca3af',marginBottom:4}}>FATTURE IN CLOUD</div>
              {selFic
                ? <div style={{fontWeight:600}}>{selFic.name} <span style={{fontSize:11,color:'#9ca3af'}}>{selFic.vat_number||''}</span></div>
                : <div style={{color:'#9ca3af',fontStyle:'italic',fontSize:13}}>← Seleziona cliente FIC</div>
              }
            </div>
            <div style={{display:'flex',gap:8}}>
              <button className="btn btn-primary" onClick={collega}
                disabled={!selDb || !selFic || saving}
                style={{whiteSpace:'nowrap'}}>
                {saving?'...':'✅ Collega'}
              </button>
              <button className="btn btn-secondary btn-sm" onClick={()=>{setSelDb(null);setSelFic(null);}}>✕</button>
            </div>
          </div>
        </div>
      )}

      {/* DUE COLONNE */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16}}>

        {/* DB LOCALE */}
        <div className="card" style={{padding:0}}>
          <div style={{padding:'10px 12px',borderBottom:'1px solid #e5e7eb',background:'#f9fafb'}}>
            <div style={{fontWeight:600,fontSize:13,marginBottom:6}}>📋 Clienti DB locale ({dbFiltrati.length})</div>
            <input className="form-control" placeholder="🔍 Cerca..."
              value={q} onChange={e=>setQ(e.target.value)} style={{fontSize:12}} />
            <div style={{display:'flex',gap:6,marginTop:6}}>
              {['tutti','collegati','non_collegati'].map(f=>(
                <button key={f}
                  className={`btn btn-sm ${filtroStato===f?'btn-primary':'btn-secondary'}`}
                  style={{fontSize:11,padding:'2px 8px'}}
                  onClick={()=>setFiltro(f)}>
                  {f==='tutti'?'Tutti':f==='collegati'?'✅ Col.':'❌ Non col.'}
                </button>
              ))}
            </div>
          </div>
          <div style={{maxHeight:500,overflowY:'auto'}}>
            {dbFiltrati.map(c => {
              const isSelected = selDb?.id === c.id;
              return (
                <div key={c.id}
                  onClick={()=>setSelDb(isSelected ? null : c)}
                  style={{
                    padding:'8px 12px', borderBottom:'1px solid #f3f4f6',
                    cursor:'pointer', fontSize:13,
                    background: isSelected ? '#fff7ed' : c.fic_cliente_id ? '#f0fdf4' : '#fff',
                    display:'flex', alignItems:'center', gap:8,
                  }}
                  onMouseEnter={e=>{ if(!isSelected) e.currentTarget.style.background='#f9fafb'; }}
                  onMouseLeave={e=>{ if(!isSelected) e.currentTarget.style.background=c.fic_cliente_id?'#f0fdf4':'#fff'; }}
                >
                  <span style={{fontSize:16}}>{c.fic_cliente_id ? '✅' : '⭕'}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.nome}</div>
                    <div style={{fontSize:11,color:'#9ca3af'}}>{c.citta||''} {c.fic_cliente_id ? `· FIC: ${c.fic_cliente_id}` : ''}</div>
                  </div>
                  {c.fic_cliente_id && (
                    <button className="btn btn-danger btn-sm" style={{fontSize:10,padding:'1px 6px'}}
                      onClick={e=>{e.stopPropagation();scollega(c);}}>✕</button>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* FATTURE IN CLOUD */}
        <div className="card" style={{padding:0}}>
          <div style={{padding:'10px 12px',borderBottom:'1px solid #e5e7eb',background:'#f9fafb'}}>
            <div style={{fontWeight:600,fontSize:13,marginBottom:6}}>💶 Clienti Fatture in Cloud ({ficFiltrati.length})</div>
            <input className="form-control" placeholder="🔍 Nome o P.IVA..."
              value={ficQ} onChange={e=>setFicQ(e.target.value)} style={{fontSize:12}} />
          </div>
          <div style={{maxHeight:500,overflowY:'auto'}}>
            {ficFiltrati.slice(0,100).map(c => {
              const isSelected = selFic?.id === c.id;
              const giàUsato   = clientiDb.some(db => db.fic_cliente_id === c.id);
              return (
                <div key={c.id}
                  onClick={()=>setSelFic(isSelected ? null : c)}
                  style={{
                    padding:'8px 12px', borderBottom:'1px solid #f3f4f6',
                    cursor:'pointer', fontSize:13,
                    background: isSelected ? '#fff7ed' : giàUsato ? '#f0fdf4' : '#fff',
                    display:'flex', alignItems:'center', gap:8,
                  }}
                  onMouseEnter={e=>{ if(!isSelected) e.currentTarget.style.background='#f9fafb'; }}
                  onMouseLeave={e=>{ if(!isSelected) e.currentTarget.style.background=giàUsato?'#f0fdf4':'#fff'; }}
                >
                  <span style={{fontSize:16}}>{giàUsato ? '✅' : '⭕'}</span>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{fontWeight:500,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{c.name}</div>
                    <div style={{fontSize:11,color:'#9ca3af'}}>{c.vat_number||''} {c.address_city||''}</div>
                  </div>
                </div>
              );
            })}
            {ficFiltrati.length > 100 && (
              <div style={{padding:'8px 12px',fontSize:12,color:'#9ca3af',textAlign:'center'}}>
                Mostrando 100 su {ficFiltrati.length} — affina la ricerca
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
